<div class="grid-wrapper">
  <div class="top-row">
    <div class="left-group">
      <select id="batchSelect" [(ngModel)]="selectedBatch" (change)="onBatchChange()" class="batch-select">
        <option value="">All Materials</option>
        <option *ngFor="let batch of batches" [value]="batch">{{ batch }}</option>
      </select>
    </div>
  </div>

  <div *ngIf="isLoading; else chartsContent" class="loading-message">
    Loading data, please wait... <div class="spinner"></div>
  </div>

  <ng-template #chartsContent>
    <!-- Bar Chart Row -->
    <div class="bar-chart-container">
      <div class="chart-column">
        <div class="chart-header">
          <h3>{{ selectedBatch === "" ? "All Materials" : selectedBatch }}</h3>
          <p>Total Items: {{ totalItems }}</p>
        </div>
        <div class="chart-wrapper">
          <canvas baseChart [data]="barChartData" [type]="barChartType" [options]="barChartOptions"></canvas>
        </div>
      </div>
    </div>

    <div class="doughnut-chart-container">
      <div class="chart-column">
        <div class="chart-header">
          <h3>{{ selectedBatch === "" ? "All Materials" : selectedBatch }}</h3>
          <p>Total Items: {{ totalItems }}</p>
        </div>
        <div class="chart-wrapper">
          <canvas baseChart [data]="doughnutChartData" [type]="doughnutChartType" [options]="doughnutChartOptions"></canvas>
        </div>
      </div>
    </div>

    <!-- Doughnut Chart and Table Row -->
    <div class="charts-and-table-container">
      <div class="table-container">
        <div class="table-wrapper">
          <!-- Table content here -->
          <div class="table-header">
            <h3>Status Summary</h3>
            <h3>{{ selectedBatch === "" ? "All Materials" : selectedBatch }}</h3>
          </div>
          <table class="status-table">
            <thead>
              <tr>
                <th>Status</th>
                <th class="text-right">Materials</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of tableData">
                <td>{{ item.status }}</td>
                <td class="text-right">{{ item.count.toLocaleString() }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </ng-template>  
</div>